











































































import { Component, Prop, Vue } from 'vue-property-decorator'
import VueQrcode from 'vue-qrcode'

import { Product } from '@/store/modules/lib'
import { namespace } from 'vuex-class'
import {urlWithContour} from "@/helpers/currentContour";

import IQR from '@/components/icons/IQR.vue'
import IEdit from '@/components/icons/IEdit.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IClose from '@/components/icons/IClose.vue'
import Tooltip from '@/components/UI/Tooltip.vue';

const auth = namespace('auth')
const roistat = namespace('roistat')
const profile = namespace("profile")

@Component({
  components: {
    VueQrcode,
    'i-qr': IQR,
    'i-edit': IEdit,
    'i-trash': ITrash,
    'i-close': IClose,
    Tooltip,
  }
})
export default class ProductItem extends Vue {
  @Prop({ type: Boolean, default: false }) protected noBorder!: boolean
  @Prop({ type: Boolean, default: false }) protected isSelected!: boolean
  @Prop({ type: Object, default: {} }) protected product!: Product

  @auth.Getter('showId') protected showId: any
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any

  protected qrDlgState: boolean = false
  protected curProductLink: string = ''
  protected curProductTitle: string = ''

  protected openProductQr (id: string, title: string): void {
    this.curProductLink = `${urlWithContour()}/p/${ id }`
    this.curProductTitle = title
    this.qrDlgState = true
    let params = [
      {
        "name": "“Продукция”: Действие “Показать QR”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  protected selected (): void {
    this.$emit('selected', this.product._id)
  }

  protected remove (): void {
    this.$emit('remove', this.product._id)
  }

  protected edit (): void {
    this.$emit('edit', this.product._id)
  }
}
